<template>
    <div>
        <a-form-model layout="inline" :model="searchForm">
            <a-form-model-item label="课程名称">
                <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="课时排序">
                <a-input-group size="large">
                    <a-row>
                        <a-col :span="11">
                            <a-input-number v-model="searchForm.minChildCourseDisplayOrder" :min="0" :max="9999" placeholder="最小值"/>
                        </a-col>
                        <a-col :span="2" style="text-align: center;line-height: 32px;padding-left: 3px;">~</a-col>
                        <a-col :span="11">
                            <a-input-number v-model="searchForm.maxChildCourseDisplayOrder"
                                            :min="searchForm.minChildCourseDisplayOrder" :max="9999"  placeholder="最大值"/>
                        </a-col>
                    </a-row>
                </a-input-group>
            </a-form-model-item>
            <a-form-model-item label="课时名称">
                <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseSessionName" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="课时类型">
                <a-select class="serach-item" allowClear v-model="searchForm.childCourseType" placeholder="请选择">
                    <a-select-option value="1" :disabled="!contentData.every(e => e.contentType != 2 && e.contentType != 5)">测评课时</a-select-option>
                    <a-select-option value="2">训练课时</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="内容组成方式">
                <a-select class="serach-item" allowClear v-model="searchForm.composeMode" placeholder="请选择">
                    <a-select-option value="0">固定内容</a-select-option>
                    <!-- <a-select-option value="1">随机内容</a-select-option> -->
                    <a-select-option value="2">智能内容</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="学段">
                <a-select allowClear v-model="searchForm.period" placeholder="请选择" mode="multiple" style="min-width: 180px;">
                    <a-select-option :value="item" :key="item" v-for="item in $data._period">
                        {{item}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item>
                <a-button @click="getPageList(1)" type="primary" html-type="button">
                    查询
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <a-table style="min-width: 800px;"
                 :columns="columns"
                 :scroll="{y: 300}"
                 rowKey="id"
                 :row-selection="rowSelection"
                 :pagination="{...tableRelevant.tablePagination, pageSizeOptions: ['10', '50', '100', '500']}"
                 :loading="tableRelevant.tableLoading"
                 :locale="tableRelevant.locale"
                 :dataSource="tableRelevant.tableDataSource">
            <div slot="courseName" slot-scope="text">
                {{ text.courseName}}{{text.period ? ' - ' + text.period : ''}}
            </div>
        </a-table>
    </div>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const columns = [
        {
            title: '关联课程',
            scopedSlots: {customRender: 'courseName'}
        },
        {
            title: '课时排序',
            dataIndex: 'childCourseDisplayOrder'
        },
        {
            title: '关联课时',
            dataIndex: 'courseSessionName'
        },
        {
            title: '课时类型',
            dataIndex: 'courseSessionTypeName'
        }
    ];
    export default {
        name: "secondStep",
        props:{
            abilityList:{
                type: Array,
                value: []
            },
            contentData: {
                type: Array,
                value: []
            },
            pageData:{
                type: Object,
                value: {}
            }
        },
        data(){
            return{
                seriesInfo: this.$store.getters["course/getSeriesInfo"](),
                searchForm:{
                    courseName: undefined,
                  courseSessionName: undefined,
                    childCourseType: undefined,
                    minChildCourseDisplayOrder: undefined,
                    maxChildCourseDisplayOrder: undefined,
                    composeMode: undefined,
                    period: undefined,
                },
                columns,
                tableRelevant: tableRelevant.call(this),
                tableSelectedRowKeys: [],
                tableSelectedRows: []
            }
        },
        computed: {
            rowSelection() {
                return {
                    selectedRowKeys: this.tableSelectedRowKeys,
                    onChange: (selectedRowKeys, selectedRows) => {
                        this.tableSelectedRowKeys = selectedRowKeys;
                        this.tableSelectedRows = selectedRows.concat(this.tableSelectedRows).reduce((pre, cur) => {
                          if (this.tableSelectedRowKeys.includes(cur.id) && !pre.some(s => s.id === cur.id)) {
                            pre.push(cur);
                          }
                          return pre;
                        }, []);
                    }
                };
            },
        },
        mounted() {
            const pageData = JSON.parse(JSON.stringify(this.pageData));
            this.tableSelectedRowKeys = pageData.selectedKeys;
            this.tableSelectedRows = pageData.selectedRows;
            this.getPageList(1);

        },
        methods: {
            getPageList(pageIndex) {
                this.searchForm.childCourseType = !this.contentData.every(e => e.contentType != 2 && e.contentType != 5) ? '2' : this.searchForm.childCourseType
                let params = {
                    courseSeriesId: this.seriesInfo.id,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    ...this.searchForm
                };
                params.minChildCourseDisplayOrder = this.searchForm.minChildCourseDisplayOrder || undefined;
                params.maxChildCourseDisplayOrder = this.searchForm.maxChildCourseDisplayOrder || undefined;
                this.tableRelevant.tableLoading = true;
                this.$http.CourseResource.contentListSerie(params).then(({ data }) => {
                  this.tableRelevant.tableDataSource = data.items;
                  this.tableRelevant.tablePagination.total = data.totalCount;
                  this.tableRelevant.tablePagination.current = data.pageIndex;
                  this.tableRelevant.tablePagination.pageSize = data.pageSize;
                }).finally(() => {
                  this.tableRelevant.tableLoading = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>
